import React from "react";
import { Link } from "react-router-dom";
import { useT } from "@/lib/i18n";

export default function NotFound() {
  const { t } = useT();
  return (
    <section data-testid="page-not-found" className="min-h-[70vh] grid place-items-center px-6">
      <div className="text-center">
        <div className="zp-label">{t("page.404.eyebrow")}</div>
        <h1 className="font-display text-4xl sm:text-6xl tracking-tighter mt-3">
          {t("page.404.title")}
        </h1>
        <p className="text-[color:var(--zp-text-2)] mt-3">
          {t("page.404.sub")}
        </p>
        <Link to="/" data-testid="notfound-home-link" className="zp-btn-primary mt-7">
          {t("common.backHome")}
        </Link>
      </div>
    </section>
  );
}
